import { css } from 'goober';
import { isEmpty } from 'mc-ui-utils';
import React, { useCallback, useEffect, useState, } from 'react';
import KnowMoreIcon from '../../../assets/know-more.svg';
import constants from '../../../constants';
import { STICKER_TRAY_ELEMENTS } from '../../../constants/interaction';
import { UIElement } from '../../../enums/UIElement';
import State from '../../../state';
import colors from '../../../styles/colors';
import font from '../../../styles/font';
import { fadeIn, fadeOut } from '../../../styles/keyframes';
import { checkUserHasLiked, toggleLikeGlance } from '../../../utils/bubble';
import { getCTA } from '../../../utils/data';
import { getFooterHeight, pingCustomAnalytics, } from '../../../utils/glanceandroidbridge';
import { getActiveInteractionVariant } from '../../../utils/interactionexputils';
import { hasKhazaddumBridge, likeGlance, onShare as onBridgeShare, openCTAView, unLikeGlance, } from '../../../utils/khazaddumbridge';
import EmojiInteractor from '../../EmojiInteractor';
import LikeDislike from '../../LikeDislike';
import LikeShare from '../../LikeShare';
import StickerTray from '../../StickerTray';
import ThreeDots from '../../ThreeDots';
import VariantsLayout from '../../VariantsLayout';
const FooterContainer = css `
  position: absolute;
  bottom: ${getFooterHeight()};
  left: 0;
  width: 100%;
`;
const DefaultContainer = css `
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
`;
const ThreeDotsContainer = (mode) => css `
  position: absolute;
  left: 20px;
  animation-name: ${mode === "FOCUS" /* FOCUS */ ? fadeOut : fadeIn};
  animation-duration: 200ms;
  animation-timing-function: linear;
  animation-fill-mode: forwards;
  ${mode === "FOCUS" /* FOCUS */ &&
    `
    pointer-events:none;
  `}
`;
const CTAButton = css `
  font-size: ${font.fontSmall};
  font-weight: ${font.fontWtBold};
  color: ${colors.white};
  border-radius: 8px;
  padding: 8px 10px;
  display: flex;
  align-items: center;
  column-gap: 8px;
  text-transform: uppercase;
  background-color: rgba(255, 255, 255, 0.25);
  backdrop-filter: blur(19px);
  border: none;
`;
const ShareTrayContainer = css `
  position: absolute;
  bottom: 0;
  right: 20px;
`;
const bridgeShare = (glanceId, shareUrl, bubbleEvent) => {
    /**
     * this callback function will be called after the share activity is over and control is back to highlights
     */
    window.menuCloseCb = () => {
        window.onScreenVisibilityChange(true, "Share" /* SHARE */);
    };
    window.onScreenVisibilityChange(false, "Share" /* SHARE */);
    if (State.hasWhatsAppInstalled) {
        onBridgeShare(glanceId, shareUrl, constants.WHATSAPP_SHARE, 'window.menuCloseCb');
        bubbleEvent.setGlanceShared(glanceId, constants.WHATSAPP_SHARE);
    }
    else {
        onBridgeShare(glanceId, shareUrl, null, 'window.menuCloseCb');
        bubbleEvent.setGlanceShared(glanceId, 'generic');
    }
};
const sendInteractionAnalytics = (glanceId, payload) => {
    const impressionId = State.impressionMap[glanceId];
    const eventType = "interaction_experiment_event" /* INTERACTION */;
    const extras = Object.assign(Object.assign({}, payload), { glanceId,
        impressionId });
    pingCustomAnalytics(eventType, extras);
};
const InteractionCTActions = ({ glance, toggleDrawerMenu, toggleAutoPlay, bubbleEvent, isWebpeek, mode, hiddenElements = {}, interactionExperiment, onToggleMode, index, }) => {
    var _a;
    const { glanceId, hasUserLiked, likeCount, shareCount, shareUrl } = glance;
    const [liked, setLiked] = useState(() => glance.hasUserLiked || checkUserHasLiked(glanceId));
    const glanceString = JSON.stringify(glance);
    const ctaText = getCTA(glance);
    const title = (_a = glance === null || glance === void 0 ? void 0 : glance.peekData) === null || _a === void 0 ? void 0 : _a.title;
    const onCTAClick = useCallback(() => {
        if (!State.isSdk) {
            toggleAutoPlay();
            State.onClickCTA(glance, index);
        }
        const startTime = Date.now();
        window.continueAutoPlay = () => {
            toggleAutoPlay();
            const duration = Date.now() - startTime;
            bubbleEvent.setGlanceCTADetails(glanceId, duration, 0, 0, startTime);
        };
        toggleAutoPlay();
        openCTAView(glanceString, 'window.continueAutoPlay');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [glanceString, toggleAutoPlay]);
    useEffect(() => {
        const liked = hasUserLiked || checkUserHasLiked(glanceId);
        setLiked(liked);
    }, [hasUserLiked, glanceId]);
    const onShare = useCallback(() => {
        if (!State.isSdk) {
            State.onClickShare(glance);
        }
        else if (hasKhazaddumBridge()) {
            bridgeShare(glanceId, shareUrl, bubbleEvent);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [glanceId, shareUrl]);
    const onLike = useCallback(() => {
        if (!glanceId)
            return;
        if (!State.isSdk) {
            const isLiked = State.onClickLike(glance);
            setLiked(isLiked);
            return;
        }
        const isLiked = toggleLikeGlance(glanceId);
        isLiked ? likeGlance(glanceId) : unLikeGlance(glanceId);
        bubbleEvent.setGlanceLikeState(glanceId, isLiked);
        setLiked(isLiked);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [glanceId]);
    useEffect(() => {
        const liked = hasUserLiked || checkUserHasLiked(glanceId);
        setLiked(liked);
    }, [glanceId, hasUserLiked]);
    const handleAnalytics = (payload) => {
        sendInteractionAnalytics(glanceId, payload);
    };
    const showCtaBtn = !isEmpty(ctaText) && !isWebpeek;
    const showThreeDots = !hiddenElements[UIElement.meatballsIcon] && State.isSdk;
    const activeVariant = getActiveInteractionVariant(interactionExperiment);
    const showStickerTray = mode === "FOCUS" /* FOCUS */ &&
        activeVariant === "emoticons" /* EMOTICONS */;
    return (React.createElement("footer", { className: FooterContainer },
        React.createElement(VariantsLayout, { mode: mode, onToggleMode: onToggleMode, title: title }, (() => {
            switch (activeVariant) {
                case "emoticons" /* EMOTICONS */:
                    return (React.createElement(EmojiInteractor, { onLike: onLike, onShare: onShare, onSendAnalytics: handleAnalytics }));
                case "likeDislike" /* LIKE_DISLIKE */:
                    return React.createElement(LikeDislike, { onSendAnalytics: handleAnalytics });
                case "likeShare" /* LIKE_SHARE */:
                    return (React.createElement(LikeShare, { liked: liked, likeCount: likeCount, onLike: onLike, shareCount: shareCount, onShare: onShare, onSendAnalytics: handleAnalytics }));
                default:
                    return null;
            }
        })()),
        React.createElement("div", { className: DefaultContainer },
            showThreeDots ? (React.createElement("div", { className: ThreeDotsContainer(mode), onClick: toggleDrawerMenu },
                React.createElement(ThreeDots, null))) : null,
            showCtaBtn ? (React.createElement("button", { className: CTAButton, onClick: onCTAClick },
                React.createElement("img", { src: KnowMoreIcon, alt: "read more" }),
                ctaText)) : null),
        showStickerTray ? (React.createElement("div", { className: ShareTrayContainer },
            React.createElement(StickerTray, { stickerList: STICKER_TRAY_ELEMENTS }))) : null));
};
export default InteractionCTActions;
//# sourceMappingURL=index.js.map